// @flow
import FutureJob from '../protocol/FutureJob';

const debug = require('../debug/debug')('wc:upload:FileUploadJob');

/**
 * A {@link FutureJob} that uploads the given file to the
 * given url. Emits 'progress' events during the execution
 * of the task, then resolves or rejects.
 */
export default class FileUploadJob extends FutureJob {
  constructor(file: File, url: string, key: any = 'key') {
    super();

    this._file = file;
    this._url = url;
    this._key = key;
  }

  get description() {
    const desc = super.description;
    return {
      label: `File upload (${desc.status})`,
      tooltip: `File: ${this._file.name}`,
      status: desc.status
    };
  }

  start() {
    debug('[start()] begin job: ', this);
    if (this._canceled) {
      debug('[start()] this._canceled. return.');
      return;
    }

    if (this._done) {
      debug('[start()] this._done. return.');
      return;
    }

    this._started = true;

    const xhr = (this._xhr = new XMLHttpRequest());
    const formData = new FormData();
    formData.append(this._key, this._file);

    xhr.upload.onprogress = (e) => {
      this.emit('progress', this, e);
    };

    xhr.upload.onerror = (e) => {
      debug('[start()] upload error for job: ', this);
      this.emit('reject', { instance: this, event: e });
    };

    xhr.upload.onload = (e) => {
      if (this._canceled) {
        return this.emit('reject', { instance: this, event: e });
      }

      debug('[start()] upload success for job: ', this);
      this.emit('resolve', { instance: this, event: e });
    };

    xhr.upload.onabort = (e) => {
      debug('[start()] upload onabort call for job: ', this);
      return this.emit('reject', { instance: this, event: e });
    }

    xhr.open('POST', this._url);
    xhr.send(formData);
  }

  cancel() {
    if (this._canceled) {
      debug('[cancel()] this._canceled. return.');
      return;
    }

    if (this._done) {
      debug('[cancel()] this._done. return.');
      return;
    }

    debug('[cancel()] canceling job: ', this);
    this._canceled = true;

    if (this._xhr && this._xhr.readyState !== 4) {
      debug('[cancel()] aborting xhr');
      this._xhr.abort();
    }
  }
}
